import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';

import React from 'react';

import { baseTheme } from '../../../theme';
import LeaderSearch from '../leader-search';
import CreatePostButton from '../../post-components/action-buttons/create-post-button';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(0),
      textAlign: 'center',
    },
    primaryColor: {
      color: theme.palette.primary.main,
    },
    copySpacer: {
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
    searchIcon: {
      position: 'relative',
      top: '5px',
    },
    joinIcon: {
      color: 'white',
      display: 'inline-block',
      backgroundColor: theme.palette.secondary.main,
      margin: '0 5px',
      padding: '2px 8px',
      borderRadius: '3px',
      fontWeight: 'bold',
    },
    searchInput: {
      margin: '0 auto',
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(4),
    },
    iconSpacer: {
      position: 'relative',
      top: '5px',
    },
  }),
);

export default function LeaderWelcome(props: any) {
  const classes = useStyles(baseTheme);

  return (
    <Grid item container className={classes.root} xs={12} direction="column">
      <Grid item>
        <Typography variant="h6" color="primary" className={classes.copySpacer}>
          You haven't followed any leaders, churches or ministries yet.
        </Typography>
      </Grid>

      <Grid item>
        <Typography className={classes.copySpacer}>
          To get started, enter a leader, church or ministry name in the search box.
        </Typography>
        <Typography className={classes.copySpacer}>
          When a list appears, click
          <CreatePostButton iconOnly displayOnly
            className={classes.iconSpacer} /> to follow a public group for that leader or
          <span className={classes.joinIcon}>Join</span>
          to be added to a closed group.
        </Typography>
        <Typography className={classes.copySpacer}>
          Once you've followed a leader, you will see
          their posts and highlights on the Reliht app feed.&nbsp;
          <span className={classes.primaryColor}><b>Download the Reliht app on
          the app stores, it's FREE!</b></span>
        </Typography>
        <Typography className={classes.copySpacer}>
          On both the website and app, you may copy
          leader posts and those posts will appear in your library.
        </Typography>
        <Typography className={classes.copySpacer}>
          Click on <SearchIcon className={classes.searchIcon} color="primary" /> any
          time you want to search for
          and follow another leader, church or ministry.
        </Typography>
        <Typography className={classes.copySpacer}>
          If you don't find your favorite leader, church or ministry in the search
          results, we welcome you to invite them to sign up for Reliht.
        </Typography>
      </Grid>

      <Grid item className={classes.searchInput}>
        <LeaderSearch />
      </Grid>
    </Grid>
  );
}
